import React from 'react';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
  blue,
	contentSection,
} from 'inside-out/global-styles';

import EDEQImg from 'inside-out/images/medicare/edeq.png';
import TSDImg from 'inside-out/images/medicare/tsd.png';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';

const MedicareForHealthProfessionalsStep1Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()} style={{marginBottom: '150px' }}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>Create an Eating Disorder Plan (EDP)</h1>
        <div style={{display: 'flex'}}>
          <div className={textStyle}>
            <p>(trigger eating disorders pathway) 90250-90257 and 90260-90263</p>
            <p>An eligible patient receives an eating disorder plan (EDP) developed by a medical practitioner in general practice (items 90250-90257), psychiatry (items 90260-90262) or paediatrics (items 90261-90263).</p>
          </div>
          <div style={{minWidth: '250px', maxWidth: '250px'}}>
            <div style={{position: 'absolute'}} className={resourceWrapper}>
              <ResourceCard
                background={ null }
                to={ '/resource-library/eating-disorder-care-plan' }
                audiences={ [] }
                title={ 'Eating Disorder Care Plan' }
                body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan' }
                date={ '1 Nov, 2019' }
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>EDE-Q</h1>
        <div className={textStyle}>Your patients can do this online in your office and get a print out of their results, or you can print a hard copy below</div>
        <div style={{display: 'flex', marginTop: '24px'}}>
          <div className={resourceWrapper} style={{marginRight: '24px'}}>
            <ResourceCard
              background={ null }
              to={ '/resource-library/eating-disorder-examination-questionnaire-ede-q' }
              audiences={ [] }
              title={ 'EDE-Q' }
              body={ 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.' }
              date={ '1 Nov, 2019' }
            />
          </div>
          <a href="/assessment?started=true">
            <img src={ EDEQImg } style={{display: 'block', margin: '0 auto'}} alt="The EDE-Q assessment" />
          </a>
        </div>
      </div>
    </section>

    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>Referring Patients</h1>
        <div className={textStyle}>
          All health professionals who plan to deliver services covered under the EDP items must be appropriately trained.
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <a href="/treatment-services">
          <img src={ TSDImg } alt="The treatment services database" />
        </a>
        <div className={textStyle} style={{marginLeft: '24px' }}>
          <h1 className={titleStyle} style={{color: blue }}>Find a Qualified Practitioner</h1>
          <p>Building the right multidisciplinary team is an important part of quality care for eating disorders and has been incorporated into this new MBS model of treatment. Search for practitioners with a declared interest in eating disorders here.</p>

          <p>The Butterfly Foundation also have a phone line referral option: 1800 33 4673</p>

          <p>ANZAED also has a search for practitioner function <a href="https://www.xcdsystem.com/ANZAED/member_directory/">here</a>.</p>
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <div className={titleStyle} style={{color: blue}}>The Approved Psychological Treatments to be Delivered Under Medicare</div>
        <div className={textStyle}>
          <p>The psychological treatments strategies that are permitted under an EDP are:</p>
          <ul>
            <li>Family Based Treatment for Eating Disorders (EDs) (including whole family, Parent Based Therapy, parent only or separated therapy)</li>
            <li>Adolescent Focused Therapy for EDs</li>
            <li>Cognitive Behavioural Therapy (CBT) for EDs (CBT-ED)</li>
            <li>CBT-Anorexia Nervosa (AN) (CBT-AN)</li>
            <li>CBT for Bulimia Nervosa (BN) and Binge-eating Disorder (BED) (CBT-BN and CBT BED)</li>
            <li>Specialist Supportive Clinical Management (SSCM) for EDs</li>
            <li>Maudsley Model of Anorexia Treatment in Adults (MANTRA)</li>
            <li>Interpersonal Therapy (IPT) for BN, BED</li>
            <li>Dialectical Behavioural Therapy (DBT) for BN, BED</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForHealthProfessionalsStep1Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/step-1.js